
import Content from './components/content/Content';
import Load from './components/load/Load';

import './App.css';
import AppProvider from './contex/AppProvider';

function App() {

  return (
    <AppProvider>
      <div className="App">
        <Load />
        <Content />
      </div>
    </AppProvider>
    
  );
}

export default App;
